import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./styles/index.css";
import { initGA } from "./utils/analytics";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);

// Defer analytics until browser is idle — keeps it out of the critical path
const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1000));
idle(() => initGA());
